module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Campos do Formulário do Passo \"" + _vm._s(_vm.step.name) + "\"")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'StepFieldDetail',
        params: {
          stepId: _vm.$route.params.stepId,
          actionId: _vm.$route.params.actionId
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Campo\n    ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.fields.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n      O passo ainda não possui campos de preenchimento.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, _vm._l((_vm.fields), function(f, index) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('span', [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'text') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'number') ? _c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }) : _vm._e(), _vm._v(" "), (f.type == 'date') ? _c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }) : _vm._e(), _vm._v(" "), (f.type == 'file') ? _c('span', {
      staticClass: "glyphicon glyphicon-file"
    }) : _vm._e(), _vm._v(" "), (f.type == 'select') ? _c('span', {
      staticClass: "glyphicon glyphicon-list"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v(" "), (f.type == 'textarea') ? _c('span', {
      staticClass: "glyphicon glyphicon-font"
    }) : _vm._e(), _vm._v(" "), (f.type == 'user') ? _c('span', {
      staticClass: "glyphicon glyphicon-user"
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(f.name) + "\n                    "), (f.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("(Obrigatório)")]) : _vm._e(), _vm._v(" "), (f.private) ? _c('span', {
      staticClass: "private"
    }, [_vm._v("(Campo Privado)")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'StepFieldDetail',
          params: {
            stepId: _vm.$route.params.stepId,
            actionId: _vm.$route.params.actionId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar campo"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover campo"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n                      ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d18b387"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepFieldList.vue
// module id = 1438
// module chunks = 1